import React from 'react';

export default function Loader() {
  return (
    <div className="loading-container">
      <div className="loading loading--rotate">
        <div className="loading__rotate-container">
          <div className="loading__ball"></div>
          <div className="loading__ball"></div>
          <div className="loading__ball"></div>
          <div className="loading__ball"></div>
        </div>

        <div className="loading__rotate-container">
          <div className="loading__ball"></div>
          <div className="loading__ball"></div>
          <div className="loading__ball"></div>
          <div className="loading__ball"></div>
        </div>

        <div className="loading__rotate-container">
          <div className="loading__ball"></div>
          <div className="loading__ball"></div>
          <div className="loading__ball"></div>
          <div className="loading__ball"></div>
        </div>
      </div>
    </div>
  );
}
